import { AHCREvent } from 'domain/ahcr-event'

export interface AttributeBreakdownEntry {
  label: string
  count: number
}

const isYes = (value: string | null): boolean => (value ?? '').toLowerCase() === 'yes'

const GENDER_LABELS: Record<string, string> = {
  male: 'Masculino',
  female: 'Feminino',
}

/** Contagem de gênero + acessórios (sim/não) sobre o conjunto de eventos já
 *  filtrado — responde "desses N eventos, quantos estão de máscara/chapéu/...".
 *  Só inclui entradas com pelo menos 1 ocorrência. */
export const buildAhcrAttributeBreakdown = (
  events: AHCREvent[]
): AttributeBreakdownEntry[] => {
  const entries: AttributeBreakdownEntry[] = []

  Object.entries(GENDER_LABELS).forEach(([value, label]) => {
    const count = events.filter((e) => (e.gender ?? '').toLowerCase() === value).length
    if (count > 0) entries.push({ label, count })
  })

  const accessoryFields: [keyof AHCREvent, string][] = [
    ['hat', 'Chapéu'],
    ['mask', 'Máscara'],
    ['glass', 'Óculos'],
    ['bag', 'Bolsa'],
    ['things', 'Objetos'],
  ]

  accessoryFields.forEach(([field, label]) => {
    const count = events.filter((e) => isYes(e[field] as string | null)).length
    if (count > 0) entries.push({ label, count })
  })

  return entries
}
